import { useContext as m, Fragment as a, useRef as i, useSyncExternalStore as h } from "react";
import { jsx as o, Fragment as f } from "react/jsx-runtime";
import { hash as l, Range as p } from "immutable";
import { m as d } from "../arrays-fVhvTJ84.js";
import { u as g } from "../refs-CANlwHhW.js";
function v(n) {
  const r = m(n);
  if (r == null)
    throw new Error("missing context");
  return r;
}
function x({
  collection: n,
  keyProvider: r,
  children: u,
  fallback: e,
  carry: t = void 0
}) {
  return /* @__PURE__ */ o(f, { children: n.length === 0 && e ? /* @__PURE__ */ o(e, {}) : d(n, (c, s) => /* @__PURE__ */ o(a, { children: u(c, s, t) }, `${r?.(c, s) ?? s}-${l(t)}`)) });
}
function E({
  times: n,
  keyProvider: r,
  children: u,
  carry: e = void 0
}) {
  return /* @__PURE__ */ o(f, { children: p(0, n).map((t) => /* @__PURE__ */ o(a, { children: u(t, e) }, `${r?.(t) ?? t}-${l(e)}`)).toArray() });
}
function w(n) {
  const r = i(null), u = g(n), e = i(() => {
    r.current === null && (r.current = u.current());
    const [, c] = r.current;
    return () => {
      c(), r.current = null;
    };
  }).current, t = i(() => (r.current === null && (r.current = u.current()), r.current[0])).current;
  return h(e, t);
}
function y(n) {
  return n.children(n.value);
}
export {
  E as For,
  x as ForEach,
  y as WithScopedVariable,
  w as useDisposable,
  v as useMandatoryContext,
  g as useUnsafeUpdatedRef
};
//# sourceMappingURL=index.js.map
